"use strict";

export var TableToolBarConstants = {
  TOOLBAR_TABLE_FORM_SET_TITLE: 'TOOLBAR_TABLE_FORM_SET_TITLE',
  TOOLBAR_TABLE_FORM_SHOW_TABLE: 'TOOLBAR_TABLE_FORM_SHOW_TABLE',
  TOOLBAR_TABLE_FORM_SET_TABLE_ELEM: 'TOOLBAR_TABLE_FORM_SET_TABLE_ELEM',
  TOOLBAR_TABLE_FORM_LOAD_BUTTONS_DATA: 'TOOLBAR_TABLE_FORM_LOAD_BUTTONS_DATA',
  TOOLBAR_TABLE_FORM_TABLE_INITIALIZED: 'TOOLBAR_TABLE_FORM_TABLE_INITIALIZED',
  TOOLBAR_TABLE_FORM_TABLE_BUTTONS_DISABLING: 'TOOLBAR_TABLE_FORM_TABLE_BUTTONS_DISABLING',
  TOOLBAR_TABLE_FORM_SET_ROW_KEY: 'TOOLBAR_TABLE_FORM_SET_ROW_KEY',
  TOOLBAR_TABLE_KEY_EVENT: 'TOOLBAR_TABLE_KEY_EVENT',
  TOOLBAR_TABLE_SET_OBJECT_NAME: 'TOOLBAR_TABLE_SET_OBJECT_NAME',
  TOOLBAR_TABLE_RESET_TABLE_SETTINGS: 'TOOLBAR_TABLE_RESET_TABLE_SETTINGS',
  TOOLBAR_TABLE_SET_FORM_FIELDS_DATA: 'TOOLBAR_TABLE_SET_FORM_FIELDS_DATA',
  TOOLBAR_TABLE_EDIT_BTN_CLICKED: 'TOOLBAR_TABLE_EDIT_BTN_CLICKED',
  TOOLBAR_TABLE_SHOW_FILTER_BTN_CLICKED: 'TOOLBAR_TABLE_SHOW_FILTER_BTN_CLICKED',
  TOOLBAR_TABLE_SELECTION_BTN_CLICKED: 'TOOLBAR_TABLE_SELECTION_BTN_CLICKED',
  TOOLBAR_TABLE_COLUMN_CHOOSER_BTN_CLICKED: 'TOOLBAR_TABLE_COLUMN_CHOOSER_BTN_CLICKED',
  TOOLBAR_TABLE_SHOW_FILTER_MODAL_CLICKED: 'TOOLBAR_TABLE_SHOW_FILTER_MODAL_CLICKED',
  TOOLBAR_TABLE_DELETE_ROWS_CLICKED: 'TOOLBAR_TABLE_DELETE_ROWS_CLICKED',
  TOOLBAR_TABLE_GOTO_CLICKED: 'TOOLBAR_TABLE_GOTO_CLICKED',
  TOOLBAR_TABLE_REPORT_CLICKED: 'TOOLBAR_TABLE_REPORT_CLICKED',
  TOOLBAR_TABLE_UPDATE_FORM_UUID: 'TOOLBAR_TABLE_UPDATE_FORM_UUID',
  TOOLBAR_TABLE_SET_DEFAULT_STATE: 'TOOLBAR_TABLE_SET_DEFAULT_STATE',
  TOOLBAR_TABLE_CLEAR_QUICK_FILTERS: 'TOOLBAR_TABLE_CLEAR_QUICK_FILTERS',
  TOOLBAR_TABLE_TOGGLE_ATTRS: 'TOOLBAR_TABLE_TOGGLE_ATTRS',
  TOOLBAR_TABLE_READONLY: 'TOOLBAR_TABLE_READONLY'
};